import { createApi } from '@reduxjs/toolkit/query/react';
import { queryRootConfig } from './http.service';

export interface NotificationReport {
  id: string;
  timestamp: string;
  type: string;
  title: string;
  message: string;
  location_id: string;
  gateway_serial: string;
  gateway_type_id: string;
  readed: boolean;
  province : string
}

export interface NotificationsReportResponse {
  cusor: {
    after: string | null;
    before: string | null;
  };
  data: NotificationReport[];
  total: number;
}

export const reportApi = createApi({
  ...queryRootConfig,
  reducerPath: 'reportApi',
  tagTypes: ['Reports'],
  endpoints: (build) => ({
    getNotificationsReport: build.query<NotificationsReportResponse, {
      receiver_id?: string;
      device_type?: string;
      type?: string;
      status?: string;
      limit?: number;
      after?: string | null;
      before?: string | null;
      from?: string | number;
      to?: string | number;
      province?: string
    }>({
      query: (params) => ({
  url: 'notifications/report',
  params: {
    receiver_id: params.receiver_id,
    device_type: params.device_type,
    type: params.type,
    status: params.status,
    limit: params.limit,
    after: params.after,
    before: params.before,
    from: params.from,
    to: params.to,
    province: params.province,
  },
}),

      providesTags: ['Reports'],
    }),
  }),
});

export const { useGetNotificationsReportQuery } = reportApi;